<template>
  <div class="list-group">
    <vue-good-table
      :columns="tableColumns"
      :rows="list"
      styleClass="vgt-table striped condensed"
      :search-options="{ enabled: true }">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'actions'">
          <b-button @click="changeSelected(props.row)">Modifica</b-button>
        </span>
        <span v-else-if="props.column.field == 'status'">
          <b-badge :variant="props.row.status === 'OPEN' ? 'success' : 'secondary'">{{props.row.status}}</b-badge>
        </span>
        <span v-else-if="props.column.field == 'startDate' || props.column.field == 'estimatedEndDate'">
          {{ props.row[props.column.field] | moment("DD/MM/YYYY HH:MM") }}
        </span>
        
      </template>
    </vue-good-table>
  </div>
</template>

<script>
export default {
  name: "LotLogList",
  props: {
    list: { type: Array, default: () => [] }
  },
  data() {
    return {
      tableColumns: [
        { label: '', field: 'actions' },
        { label: 'Codice Lotto', field: 'lotCode' },
        { label: 'Prodotto', field: 'product' },
        { label: 'Alcol Desiderato', field: 'desiredAlcohol' },
        { label: 'Data Inizio', field: 'startDate' },
        { label: 'Stima Fine', field: 'estimatedEndDate' },
        { label: 'Stato', field: 'status' },
        
      ]
    }
  },
  methods: {
    changeSelected(row) {
      this.$emit("lotlogChanged", row);
    }
  }
}
</script>
